import { useLanguage } from '@/contexts/language-context';
import { Label } from '@/components/ui/label';
import type { JobCrewScope } from '@/lib/api/jobs';

interface Props {
  id: string;
  value: JobCrewScope;
  onChange: (value: JobCrewScope) => void;
}

// The all | upcoming | unstarted picker shared by every bulk crew action.
// "Upcoming" is the safe mid-contract default and is set by the callers.
export function ScopeSelect({ id, value, onChange }: Props) {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>{t.seriesScopeLabel}</Label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value as JobCrewScope)}
        data-testid={id}
        className="px-3 py-2 text-sm border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring"
      >
        <option value="upcoming">{t.seriesScopeUpcoming}</option>
        <option value="unstarted">{t.seriesScopeUnstarted}</option>
        <option value="all">{t.seriesScopeAll}</option>
      </select>
    </div>
  );
}
